import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenService } from '@services/auth/token.service';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(public http: HttpClient, private _token: TokenService) {}

  viewPaymentDoc(auctionId) {
    const URL = `${environment.recycleApi}auction/payment/doc/details/${auctionId}`;

    return this.http
      .get(URL, { headers: this._token.getTokenHeader() })
      .pipe(map((result: object) => result));
  }

  paymentDocStatus(auctionId: string, status: object) {
    const URL = `${environment.recycleApi}auction/payment/doc/status/${auctionId}`;

    return this.http
      .post(URL, status, { headers: this._token.getTokenHeader() })
      .pipe(map((result: object) => result));
  }

  vehicleRecycle(auctionId: string) {
    const URL = `${environment.recycleApi}auction/recycle/${auctionId}`;

    return this.http.post(URL, '', { headers: this._token.getTokenHeader() });
  }
}
